import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

export const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;

  color: #000000;
  font-weight: 400;
  font-size: 13px;
  font-family: ${fontRobotoCondensed};

  opacity: 0.7;
`;

export const BoldWord = styled.div`
  display: flex;

  color: #000000;
  font-weight: 700;
  white-space: pre;
`;
